let UUID = 0;

export default class CoreExpandable extends HTMLElement {
    
    constructor() {
        super();
        this._opened = false
        this.el = this;
        this.toggleState = this.toggleState.bind(this);
    }

    connectedCallback() {

        let id = 'core-expandable' + (UUID++);
        
        this.style.display  = 'block';
        this.style.position = 'relative';

        this.$button  = this.querySelector('[core-expandable-button]');
        this.$content = this.querySelector('[core-expandable-content]');
        
        this.$button.setAttribute('id', `${id}-title`);
        this.$button.setAttribute('aria-controls', `${id}-content`);
        this.$button.addEventListener('click', this.toggleState);
        
        this.$content.setAttribute('id', `${id}-content`);
        this.$content.setAttribute('aria-labelledby', `${id}-title`);
        this.$content.setAttribute('aria-hidden', true);
        this.$content.style.display = 'none';

    }

    toggleState() {
        
        this._opened = !this._opened;

        if (this._opened) {
            
            this.$button.setAttribute('aria-expanded','true');
            this.$content.removeAttribute('aria-hidden','false');

            this.$content.style.transition = 'none' ;
            this.$content.style.removeProperty('max-height') ;
            this.$content.style.opacity    = 0;
            this.$content.style.position   = 'absolute';
            this.$content.style.visibility    = 'hidden';
            this.$content.style.display    = 'block';
            this.$content.style.overflow    = 'hidden';
            requestAnimationFrame(()=>{
                const h = this.$content.clientHeight;
                this.$content.style.maxHeight = 0  + 'px';
                this.$content.style.removeProperty('position') ;
                requestAnimationFrame(()=>{
                    this.$content.style.transition = 'max-height 1.3s var(--alias-easeOut)' ;
                    this.$content.style.opacity    = 1;
                    this.$content.style.visibility    = 'visible';
                    this.$content.style.maxHeight   = h  + 'px';
                    this.classList.add('is-opened');
                });
            });
        }
        else {
            this.$button.setAttribute('aria-expanded','false');
            this.$content.removeAttribute('aria-hidden','false');
            this.$content.style.transition = 'max-height 1s var(--alias-easeOut), visibility 0s 1s var(--alias-easeOut)' ;
            this.$content.style.maxHeight  = 0  + 'px';
            this.$content.style.visibility = 'hidden';
            this.classList.remove('is-opened');
        }
    }

    disconnectedCallback() {
        this.$button.addEventListener('click', this.toggleState);
    }

}

customElements.define('core-expandable', CoreExpandable);